/**
 * @generated SignedSource<<dd9233cd593f1ec4beb17923c868fce8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DailyDealsTable_refetchableBrand$data = {
  readonly dailyDeals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DailyDealTableRow_dailyDeal">;
      };
    }>;
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "DailyDealsTable_refetchableBrand";
};
export type DailyDealsTable_refetchableBrand$key = {
  readonly " $data"?: DailyDealsTable_refetchableBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"DailyDealsTable_refetchableBrand">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "dailyDeals"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "audienceFilter"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "languageFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./DailyDealsTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "DailyDealsTable_refetchableBrand",
  "selections": [
    {
      "alias": "dailyDeals",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "audienceIds",
              "variableName": "audienceFilter"
            },
            {
              "kind": "Variable",
              "name": "audienceLanguages",
              "variableName": "languageFilter"
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        }
      ],
      "concreteType": "GraphQLDailyDealConnection",
      "kind": "LinkedField",
      "name": "__DailyDealsTable_dailyDeals_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLDailyDealEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLDailyDeal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DailyDealTableRow_dailyDeal"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "abeb4a1484c8a743a7f4320d034227f1";

export default node;
